import Vue from 'vue'
import Vuex from 'vuex'
import { isDocApplication } from '@/utils/app.js'

import * as settings from '@/store/modules/settings/settings.js'
import * as notification from '@/store/modules/notification.js'
import * as demo from '@/store/modules/demo/demo.js'
import * as aboutMik from '@/store/modules/about/mik.js'
import * as aboutDoc from '@/store/modules/about/doc.js'
import * as user from '@/store/modules/user.js'
import * as dashboard from './modules/dashboard'
import * as report from './modules/report'
import * as product from '@/store/modules/product.js'
import * as procedure from '@/store/modules/procedure/procedure.js'
import * as claim from '@/store/modules/claim/claim.js'
import * as contract from '@/store/modules/contract/contract.js'
import * as order from '@/store/modules/order/order.js'
import * as crossRelations from '@/store/modules/cross_relations.js'
import * as companyInfo from './modules/company_info'
import * as dict from './modules/dict'
import * as router from './modules/router'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    settings,
    notification,
    demo,
    about: isDocApplication() ? aboutDoc : aboutMik,
    user,
    dashboard,
    report,
    product,
    procedure,
    claim,
    contract,
    order,
    crossRelations,
    companyInfo,
    dict,
    router
  },
  state: {},
  mutations: {},
  actions: {}
})

export default store
